import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { reservationByIdQueryOptions } from '@/core/components/sites/site/reservation/reservationsQueryOptions'
import { redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const staySearcSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(10),
  search: z.string().catch(''),
  sortBy: z
    .enum([
      'roomId',
      'roomName',
      'rateId',
      'checkIn',
      'checkOut',
      'subreservationId',
      'upgradeRoomId',
      'adults',
      'children',
      'rooms',
      'occupancy',
      'nightsOrDays',
      'totalAmount',
      'checkInCheckOut',
      'status',
      'refunded',
      'rateName',
      'rooms',
      'earlyCheckIn',
      'lateCheckOut',
      'addons',
      'externalId',
      'bookingId',
    ])
    .catch('roomName'),
  orderBy: z.enum(['asc', 'desc']).catch('desc'),
})

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/reservations/$purchaseId/'
)({
  validateSearch: (search) => staySearcSchema.parse(search),
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
  },
  loader: async ({
    context: { queryClient, auth },
    params: { siteId, purchaseId },
  }) => {
    await queryClient.ensureQueryData(
      reservationByIdQueryOptions(siteId, purchaseId, auth.token!)
    )
  },
  errorComponent: ErrorComponent,
  pendingComponent: LoadingList,
})
